import Vue from 'vue'
import App from './App.vue'
// import 'swiper/css';
import router from "@/router";
import './assets/css/mainStyle.css';
import VueMeta from "vue-meta"
import 'bootstrap/dist/css/bootstrap.min.css';
import 'swiper/swiper-bundle.min.css';
import VueVideoPlayer from 'vue-video-player'
import Axios from "axios"
import pagination from "shetabit-laravel-vue-pagination"
import 'vue-it-bigger/dist/vue-it-bigger.min.css'
import 'v-slim-dialog/dist/v-slim-dialog.css'
import SlimDialog from 'v-slim-dialog'
import Vuelidate from 'vuelidate'
Vue.component("pagination", pagination);
Vue.use(VueMeta)
Vue.use(SlimDialog);
Vue.prototype.$axios = Axios;
require('bootstrap');
Vue.config.productionTip = false
import 'video.js/dist/video-js.css';
Vue.use(VueVideoPlayer)
Vue.use(Vuelidate)
Axios.defaults.baseURL = "https://api.infinity-align.com/api/v1";
new Vue({
    created() {
        if (this.homeData == null) {

            this.$axios.get("/home").then(response => {
                let settings = {};
                response.data.home.settings.forEach((item) => {
                    settings[item.name] = item.value
                })
                response.data.home.settings = settings;
                let provinces = {};
                response.data.home.provincesWithDoctors.forEach((item) => {
                    item.doctors=[];
                    item.cities.forEach((city)=>{
                        item.doctors.push(...city.doctors)
                    })
                    provinces[item.id] = item
                })
                response.data.home.provincesWithDoctors = provinces;
                let menus = {
                    header: [],
                    footer: []
                }
                response.data.home.menus.forEach(item => {
                    if (item.group_id == 1) {
                        menus.header.push(item)
                    } else {
                        menus.footer.push(item)
                    }
                })
                response.data.home.menus = menus
                this.homeData = response.data.home;
                console.log(this.homeData)
            })

            //** MarginTop of MAin **//

            document.querySelector('.main').style.marginTop = document.querySelector('.top-header2').offsetHeight + 'px';
        } else {

            //** MarginTop of MAin **//

            document.querySelector('.main').style.marginTop = document.querySelector('.top-header2').offsetHeight + 'px';
        }
    },
    data() {
        return {
            homeData: null,

        }
    },
    render: h => h(App),
    router,
}).$mount('#app')